import {ClaimsActivityApi} from '@peachy/claims-activity-pure'
import {GeoLocationServiceClient} from '@peachy/geo-location-client'
import {DocGenApi} from '@peachy/doc-gen-pure'
import {FlashRepoApi} from '@peachy/flash-repo-pure'
import {UserAdminApiGateway} from '@peachy/web-dashboard-pure'

export interface ILambdaApiProvider {
    docApi(): Promise<DocApiService>
    claimsActivityApi(): Promise<ClaimsActivityApi>
    adminRepoApi(): Promise<FlashRepoApi>
    userAdminApi(): Promise<UserAdminApiGateway>
    geoLocationApi(): GeoLocationServiceClient
}

interface DocApiService extends DocGenApi {
    getPdfLink(ticketId: string, asFile: string): string
}
